import p from './paragraphs';
import icon from './svgs';

const radio = {
  mt: 3,
  '& > label': {
    fontWeight: '400 !important',
    fontFamily: 'body',
  },
};

const iconTextItem = {
  display: 'flex',
  alignItems: 'center',
  ...p.bodyRegular,
  color: 'main.1',
  '& >svg': {
    ...icon.iconLink,
    mr: 2,
  },
};

const iconSortingTextItem = {
  display: 'flex',
  alignItems: 'center',
  ...p.footnoteRegular,
  color: 'main.1',
  '& >svg': {
    ...icon.iconSortingLink,
  },
};

const iconTextNotification = {
  display: 'flex',
  alignItems: 'center',
  ...p.bodyRegular,
  color: 'error',
  '& >svg': {
    ...icon.iconLinkError,
    mr: 2,
  },
};

const radioGroup = {
  label: {
    ml: 2,
  },
};

const requiredSymbol = {
  ...p.footnoteImportant,
  lineHeight: 0,
  ml: '3px',
  color: 'error',
};

const footnoteRegularToCaption = {
  ...p.footnoteRegular,
  fontSize: [1, 1, 2],
};

const captionRegularSmall = {
  ...p.bodyRegular,
  fontSize: 0,
};

const spanVariants = {
  iconTextItem,
  iconSortingTextItem,
  iconTextNotification,
  radio,
  radioGroup,
  requiredSymbol,
  footnoteRegularToCaption,
  captionRegularSmall,
};

export default spanVariants;
